import React from 'react';
import { 
  MessageCircle, 
  ClipboardCheck, 
  Search, 
  Calendar, 
  Users, 
  LineChart,
  Trophy
} from 'lucide-react';

const steps = [
  {
    icon: MessageCircle,
    title: 'Inscrição',
    description: 'Entre em contato diretamente com nossa equipe clicando no botão "Fale Conosco" ou nas opções de WhatsApp e formulário de contato. Receba informações iniciais e oriente-se sobre os próximos passos.',
  },
  {
    icon: Search,
    title: 'Análise de Perfil',
    description: 'Preencha o formulário inicial com suas informações e objetivos. Compartilhe suas expectativas para a mentoria, ajudando-nos a entender suas necessidades e metas específicas.',
  },
  {
    icon: ClipboardCheck,
    title: 'Diagnóstico Personalizado',
    description: 'Realizamos uma avaliação detalhada para identificar seus pontos fortes e áreas de desenvolvimento. Baseando-se nessa análise, você receberá uma proposta personalizada, incluindo o plano mais adequado às suas necessidades.',
  },
  {
    icon: Calendar,
    title: 'Cronograma de Estudos',
    description: 'Início do plano com um cronograma adaptado à sua rotina e objetivos. Orientação prática sobre como estudar de forma eficiente, respeitando seu tempo e ritmo.',
  },
  {
    icon: Users,
    title: 'Acompanhamento Contínuo e Ativo',
    description: 'Encontros semanais com atividades lúdicas, práticas e interativas. Desenvolvimento constante por meio de técnicas específicas para melhorar desempenho em redação, interpretação de texto e áreas relacionadas.',
  },
  {
    icon: LineChart,
    title: 'Revisões e Feedback Regular',
    description: 'Revisões periódicas para ajustar o plano conforme necessário. Feedback contínuo para alunos e pais, garantindo alinhamento e clareza sobre o progresso.',
  },
  {
    icon: Trophy,
    title: 'Alcançando Resultados e Celebrando Conquistas',
    description: 'Acompanhamos de perto seu desenvolvimento até alcançar seus objetivos. Celebramos suas conquistas, destacando o progresso feito ao longo da mentoria.',
  },
];

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="py-20 bg-primary">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Como Funciona a Mentoria
          </h2>
          <p className="text-xl text-white/80 max-w-3xl mx-auto">
            Um processo estruturado e personalizado para garantir seu sucesso na redação.
          </p>
        </div>

        <div className="relative">
          <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 h-full w-0.5 bg-white/20" />

          <div className="space-y-12">
            {steps.map((step, index) => (
              <div
                key={step.title}
                className={`flex flex-col md:flex-row items-center ${
                  index % 2 === 0 ? 'md:flex-row-reverse' : ''
                }`}
              >
                <div className="md:w-1/2">
                  <div className="relative">
                    {/* Mobile step number - positioned above the card */}
                    <div className="md:hidden flex justify-center mb-4">
                      <div className="h-12 w-12 bg-accent rounded-full flex items-center justify-center text-white font-bold text-xl">
                        {index + 1}
                      </div>
                    </div>
                    
                    <div
                      className={`max-w-md mx-auto p-6 bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow border border-white/10 ${
                        index % 2 === 0 ? 'md:ml-auto' : ''
                      }`}
                    >
                      <step.icon className="h-12 w-12 text-accent mb-4" />
                      <h3 className="text-xl font-bold text-primary mb-2">
                        {step.title}
                      </h3>
                      <p className="text-primary/80">{step.description}</p>
                    </div>
                  </div>
                </div>
                
                {/* Desktop step number */}
                <div className="hidden md:block md:w-16 relative">
                  <div className="h-12 w-12 bg-accent rounded-full flex items-center justify-center text-white font-bold text-xl absolute left-1/2 transform -translate-x-1/2">
                    {index + 1}
                  </div>
                </div>
                <div className="md:w-1/2" />
              </div>
            ))}
          </div>
        </div>

        <div className="text-center mt-16">
          <a
            href="#contact"
            className="inline-block px-8 py-4 bg-accent text-white rounded-full text-lg font-semibold hover:bg-accent-dark transition-colors"
          >
            Agende uma conversa para descobrir o plano ideal
          </a>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;